import { render } from "./theme34.vue?vue&type=template&id=583fc83d&scoped=true"
import script from "./theme34.vue?vue&type=script&lang=js"
export * from "./theme34.vue?vue&type=script&lang=js"

import "./theme34.vue?vue&type=style&index=0&id=583fc83d&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-583fc83d"

export default script